import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterMui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 19,
	viewBox: "0 0 22 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M20.8047 1.80469C20.5312 1.17969 19.8672 0.75 19.1641 0.75H2.79688C2.09375 0.75 1.42969 1.17969 1.15625 1.80469C0.84375 2.42969 0.960938 3.17188 1.39062 3.67969L7.83594 11.6094V14.2656C7.83594 14.7734 8.10938 15.2031 8.5 15.5156L11.7031 17.9766C11.9766 18.1719 12.2891 18.25 12.6016 18.25C13.4219 18.25 14.0859 17.5859 14.0859 16.7656V11.6094L20.5703 3.67969C21 3.17188 21.1172 2.42969 20.8047 1.80469ZM12.5234 10.5938C12.3281 10.8281 12.2109 11.1016 12.2109 11.4141V16.0234L9.71094 14.0703V11.4141C9.71094 11.1016 9.63281 10.8281 9.4375 10.5938L2.95312 2.66406H19.0078L12.5234 10.5938Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgFilterMui);
export { ForwardRef as ReactComponent };
